module.exports = __webpack_public_path__ + "static/media/robo.a81d161f.png";